export const mapConfig = {
    mapOptions: {
        container: 'map',
        zoom: 5.5,
        center: [-70.5, 49],
        maxZoom: 19.5,
        minZoom: 5.5,
    }
};
